import styled from 'styled-components';

export default styled.div`
  .coupon-button-wrap {
    padding-top: 48px;
    .loading-button {
      color: #fff;
      background-color: ${(props) => props.theme.palette.primary.main};
    }
  }
  .display-row-between {
    display: flex;
    justify-content: space-between;
  }
  .display-row {
    display: flex;
  }
  .input-error-style {
    color: #f44336;
    margin: 0;
    font-size: 0.75rem;
    margin-top: 3px;
    text-align: left;
    font-family: 'Roboto', 'Helvetica', 'Arial', sans-serif;
    font-weight: 400;
    line-height: 1.66;
    /* margin-left: 14px; */
    letter-spacing: 0.03333em;
  }
  .upload-image-item:hover .montmorillonite-layer-wrap {
    display: block;
  }
  .upload-image-item:hover .montmorillonite-layer-in {
    display: flex;
    justify-content: center;
  }

  .montmorillonite-layer-wrap {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: #000;
    opacity: 0.5;
    display: none;
  }
  .montmorillonite-layer-in {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    color: #ffffff;
    display: none;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    /* flex-wrap: wrap; */
    /* padding: 0 35px; */
    box-sizing: border-box;
    background-color: transparent;
    gap: 0 16px;
    .icon-wrap {
      /* width: 32px;
      height: 32px;
      background-color: #ffffff; */
      border-radius: 50%;
      .icon-box {
        width: 100%;
        height: 100%;
        background-color: #000000;
        opacity: 0.7;
        border-radius: 50%;
        padding: 6px;
        box-sizing: border-box;
        .icon-style {
          width: 100%;
          height: 100%;
          color: #fff;
          cursor: pointer;
        }
      }
    }
  }
  .MuiFormControlLabel-label {
    color: rgba(0, 0, 0, 0.87);
  }
  .number-input-algin-right {
    .MuiInput-input {
      text-align: right;
    }
  }
  .next-button-icon {
    transform: rotateY(180deg);
  }
  .checkbox-radio-disabled-color .Mui-disabled {
    color: darkgray;
  }
`;
